// extracted by mini-css-extract-plugin
export default {"card":"style_card__9r-Ff","cButton":"style_cButton__leZM0"};